/**
 * userProfileStore — learner profile slice (Zustand).
 *
 *   GET   /api/learners/me
 *   PATCH /api/learners/me   ({ name, phone, avatar })
 */
import { apiRequest } from "./userUtils";
import { toDisplayString } from "../../utils/toDisplayString";

export const userProfileInitialState = {
  userProfile: null,
  userProfileLoading: false,
  userProfileError: null,
};

export function createUserProfileActions(set, get) {
  return {
    // GET /api/learners/me
    fetchUserProfile: async () => {
      set({ userProfileLoading: true, userProfileError: null });
      try {
        const data = await apiRequest(get, "/api/learners/me");
        const profile = data?.user || data?.data || data;
        set({ userProfileLoading: false, userProfile: profile });
        return { success: true, profile };
      } catch (err) {
        const msg = toDisplayString(err.message, "Failed to fetch profile");
        set({ userProfileLoading: false, userProfileError: msg });
        return { success: false, error: msg };
      }
    },

    // PATCH /api/learners/me
    updateUserProfile: async (payload) => {
      set({ userProfileLoading: true, userProfileError: null });
      try {
        const data = await apiRequest(get, "/api/learners/me", { method: "PATCH", body: payload });
        const profile = data?.user || data?.data || data;
        set({
          userProfileLoading: false,
          userProfile: profile,
          successMessage: "Profile updated successfully",
        });
        return { success: true, profile };
      } catch (err) {
        const msg = toDisplayString(err.message, "Failed to update profile");
        set({ userProfileLoading: false, userProfileError: msg });
        return { success: false, error: msg };
      }
    },
  };
}

const userProfileActions = createUserProfileActions;
export default userProfileActions;
